import { useTranslation } from 'react-i18next';
import './LanguagePicker.css';

export type Props = {
    onLanguageChange: (langCode: string) => void;
};

const languages = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    it: 'Italiano',
} as any;

export const LanguagePicker = ({ onLanguageChange }: Props) => {
    const { i18n } = useTranslation();
    const langCode = (i18n.language || 'en-US').split('-')[0].toUpperCase();
    return (
        <div
            id="language-picker"
            className="ui compact menu"
        >
            <div className="ui simple right dropdown item">
                <span className="current-language">
                    { langCode }
                </span>
                <i className="dropdown icon"/>
                <div className="menu">
                    { Object.keys(languages).map(langCode =>
                        <div
                            key={ langCode }
                            id={ `lang-${langCode}` }
                            className="item"
                            onClick={ () => onLanguageChange(langCode) }
                        >
                            { languages[langCode] }
                        </div>
                    ) }
                </div>
            </div>
        </div>
    );
};
